import { create } from 'zustand'
import { combine, devtools } from 'zustand/middleware'

/**
 * Session-scoped registry of lab orders this client dispatched to Health
 * Gorilla. Used to gate toast UX so we only raise success/error toasts for
 * submissions initiated in *this* tab — refreshes don't recreate stale toasts
 * because the source of truth (the `submissionState` tag on the order) is
 * already reflected in the order's pulsing status icon.
 */
export const useInFlightLabSubmissionsStore = create(
  devtools(
    combine(
      {
        dispatchedOrderIds: new Set<string>(),
      },
      (set) => ({
        add: (orderId: string) => {
          set((state) => {
            const next = new Set(state.dispatchedOrderIds)
            next.add(orderId)
            return { dispatchedOrderIds: next }
          })
        },
        remove: (orderId: string) => {
          set((state) => {
            if (!state.dispatchedOrderIds.has(orderId)) {
              return state
            }
            const next = new Set(state.dispatchedOrderIds)
            next.delete(orderId)
            return { dispatchedOrderIds: next }
          })
        },
      })
    )
  )
)
